import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Alternativ tekst mangler for dette bildet',
    noAnswers: 'Ikke noe svaralternativ, klikk ved siden av for å fortsette.',
    placeholder: 'Spesifiser...',
    pleaseSelect: 'Velg...',
    rotateLandscape: 'Slå av orienteringslåsen på telefonen og vri den til breddevisning for å fortsette.',
    rotatePortrait: 'Vri telefonen fra breddevisning til portrett for å fortsette.',
    ir: {
      selectWebCam: 'Velg webkamera (hvis tilgjengelig) eller klikk på «Bla gjennom» for å laste opp fra enheten',
      uploadOnly: 'Klikk på «Bla gjennom» for å laste opp fra enheten',
      noWebCam: 'Ingen webkamera oppdaget',
      accessCamUpload: 'FÅ TILGANG TIL KAMERA / LAST OPP',
      browse: 'BLA GJENNOM',
      uploadPhoto: 'Last opp et bilde',
      camera: 'Webkamera',
      instead: 'i stedet',
      capture: 'OPPTAK',
      somethingWrong: 'Beklager, noe gikk galt. Prøv igjen senere',
      couldntRead: 'Beklager, vi kunne ikke lese koden!',
      couldntProcess: 'Beklager, vi kunne ikke behandle bildet ditt!',
      inValidCode: 'Send inn den gyldige koden',
      moveOn: 'Prøv på nytt eller send inn bildet ditt og fortsett',
      tryAgain: 'Prøv på nytt',
      dataReceived: 'Data motatt!',
      enterManually: 'Prøv på nytt eller skriv inn dataene manuelt nedenfor',
      positionQR:
        'Plasser QR–koden foran kameraet slik at den fyller den røde rammen, eller last den opp fra datamaskinen.',
      positionQRMobile:
        'Plasser QR–koden foran kameraet slik at den fyller den røde rammen, eller last den opp fra datamaskinen.',
      analyzing: 'Analyserer bilde, vennligst vent',
      submit: 'SEND INN',
      startOver: 'Start på nytt',
      allDone: 'Ferdig!',
      cantAnalyze:
        'Oppmerksomhet – vi kunne ikke gjengi dette bildet. Prøv å sende inn på nytt eller velg et mer generisk bildeformat (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Vi beklager – vi støtter ikke dette filformatet. Last opp en støttet bildetype (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Ingen webkamera oppdaget',
      uploadVideo: 'Last opp en video',
      skip: 'Hoppe over?',
      accessCamUpload: 'FÅ TILGANG TIL KAMERA / LAST OPP',
      browse: 'BLA GJENNOM',
      instead: 'i stedet',
      or: 'eller',
      stopRecording: 'Stopp opptak',
      willBeStopped: 'Innspillingen vil stoppe etter <b>5 minutter</b>',
      stopOnDone: 'Stopp opptaket når du er ferdig!',
      record: 'POST',
      somethingWrong: 'Beklager, noe gikk galt. Prøv igjen senere.',
      dataReceived: 'Mottok data!',
      microphone: 'Mikrofonen',
      camera: 'Webkamera',
      selectMicrophone: 'Velg mikrofonen din',
      selectCam: 'Velg webkamera',
      submit: 'SEND INN',
      upload: 'Last opp ',
      playback: 'Avspilling',
      stopPlayback: 'STOPP AVSPILLING',
      startOver: 'Start på nytt',
      allDone: 'Ferdig!',
      alternativeRecordSpan: 'Last opp et videoklipp fra datamaskinen. Alternativt kan du ',
      alrenativeRecordHref: 'ta opp videoen med et webkamera.',
      cantAnalyze:
        'Oppmerksomhet – vi kunne ikke gjengi denne videoen. Prøv å sende inn på nytt eller velg et mer generisk videoformat (MP4, M4V, WEBPM)',
      wrongFormat:
        'Vi beklager – vi støtter ikke dette filformatet. Last opp en støttet videotype (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'VELG',
      pleaseChoose: 'Velg',
      this: 'DENNE',
      one: ' én',
      myChoice: 'Mitt VALG'
    },
    hm: {
      addComment: 'Legg til en kommentar nedenfor',
      commentMandatoryPlaceHolder: 'Legg til obligatorisk kommentar... ',
      commentOptionalPlaceHolder: 'Legg til valgfri kommentar... ',
      dragPin: 'Dra for å flytte (langt klikk / trykk for presisjonsnål). ',
      removePin: 'Dra utenfor bildet for å slette.  ',
      editComment: 'Klikk på / trykk på pinnen for å redigere kommentaren. ',
      addPin: 'Dra pinnen fra panelet nedenfor og slipp den på et sted du velger på bildet.',
      addPins: 'Dra pinnene fra panelet nedenfor og slipp dem på et sted du velger på bildet.',
      leavePins: (minPoints, maxPoints) =>
        `Legg igjen minst ${minPoints}, men ikke mer enn ${maxPoints} pinner av hvert slag`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Legg igjen minst ${minPoints}, men ikke mer enn ${maxPoints} pinner av noe slag.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Legg igjen minst ${minPoints}, men ikke mer enn ${maxPoints} pinner.`,
      leavePinsWithOff: maxPoints =>
        `Ikke legg igjen mer enn ${maxPoints} pinner av hvert slag, eller klikk på Neste for å hoppe over.`,
      leavePinsWithOffAny: maxPoints =>
        `Ikke legg igjen mer enn ${maxPoints} pinner av noe slag være igjen, eller klikk på Neste for å hoppe overfor å hoppe over.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Ikke legg igjen mer enn ${maxPoints} pinner eller klikk Neste for å hoppe over.`,
      leavePinWithOff: `Ikke legg igjen mer enn 1 pinne av hvert slag, eller klikk Neste for å hoppe over.`,
      leavePinWithOffAny: `Ikke legg igjen mer enn 1 pinne av noe slag eller klikk Neste for å hoppe overfor å hoppe over.`,
      leavePinPerPageWithOff: 'Ikke legg igjen mer enn 1 pinne eller klikk Neste for å hoppe over.',
      leaveExactlyPin: `Legg igjen 1 pinne av hvert slag.`,
      leaveExactlyPinAny: `Legg igjen 1 pinne av et hvilket som helst slag.`,
      leaveExactlyPinPerPage: 'Legg igjen 1 pinne.',
      leaveExactlyPins: maxPoints => `Legg igjen ${maxPoints} pinner av hvert slag.`,
      leaveExactlyPinsAny: maxPoints => `Legg igjen ${maxPoints} pinner av noe slag.`,
      leaveExactlyPinsPerPage: maxPoints => `Legg igjen ${maxPoints} pinner.`,
      leaveComment: 'Skriv under bildet for å legge igjen en kommentar.',
      noAnswers: 'Ikke noe svaralternativ, klikk ved siden av for å fortsette.',
      outOfPins: 'Du er tom for pinner',
      pinsBehavior: 'Når du beveger deg over bildet, vil du se områder som vil bli uthevet med en enkelt pinne.',
      clusters: 'Du kan bare plassere pinner i disse uthevede områdene.',
      contentAware: 'Du kan slippe pinner innenfor eller utenfor de markerte områdene.'
    },
    mp: {
      expand_note: 'Nei, det er ingen barn under 18 år som bor i min husholdning',
      rb_note: rows => `Velg bare 1 svar per element${rows ? ' nedenfor' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Velg ${min !== 1 ? '' : 'bare'} ${min} svar per element${rows ? ' nedenfor' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Velg minst ${min} svar, men ikke mer enn ${max} per element${rows ? ' nedenfor' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Velg minst ${min} svar per element${rows ? ' nedenfor' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Ikke velg mer enn ${max} svar per element${rows ? ' nedenfor' : ''}:`
        } else {
          return 'Sjekk alle som gjelder:'
        }
      }
    },
    sh: {
      note: 'Klikk på et produkt for å zoome inn og legge til i den virtuelle handlekurven hvis du vil kjøpe det i butikken',
      amazonNote:
        'Klikk på et produkt for å zoon zoome inn og legge til i den virtuelle handlekurven hvis du vil kjøpe det på nettet',
      fullCart: 'Handlekurven din er full!',
      qty: 'ANTALL',
      addToCart: 'LEGG I HANDLEKURV',
      each: 'hver',
      items: 'varer',
      deleteFromCart: 'SLETT',
      emptyCard: 'Handlekurven din er tom',
      total: 'Handlekurv',
      clearCart: 'Fjern handlekurv',
      backToStore: 'Tilbake til butikken',
      scrollError: `Gå helt til venstre og så til høyre for å fortsette spørreundersøkelsen. `,
      na: 'Ingen av de ovennevnte',
      next: 'NESTE'
    },
    rb: {
      note: 'Bare velg ett element:'
    },
    vo: {
      note: 'Se videoen til slutten'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Sjekk alle som gjelder:'
        } else if (min === max) {
          return `Velg ${min !== 1 ? 'hvilket som helst' : 'nøyaktig'} ${min} element${min !== 1 ? 's' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Velg minst ${min} element${min !== 1 ? 's' : ''}, men ikke mer enn ${max}:`
        } else if (5000 === max && min > 0) {
          return `Velg minst ${min} element${min !== 1 ? 's' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Ikke velg mer enn ${max} element${max !== 1 ? 's' : ''}:`
        } else {
          return 'Sjekk alle som gjelder:'
        }
      }
    },
    oe: {
      na: 'Ikke aktuelt',
      note: (min, max, optional) => {
        if (min === max) {
          return `Skriv inn ${1 !== min ? 'hvilket som helst' : 'nøyaktig'} ${min} tegn${1 !== min ? 's' : ''}${
            optional ? ' (valgfritt)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Skriv inn minst ${min} tegn${1 !== min ? 's' : ''} men ikke mer enn ${max}${
            optional ? ' (valgfritt)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Skriv inn minst ${min} tegn${1 !== min ? 's' : ''}${optional ? ' (valgfritt)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Ikke skriv mer enn ${max} tegn${1 !== min ? 's' : ''}${optional ? ' (valgfritt)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Fyll ut følgende felt:'
    },
    mx: {
      note: 'Flytt de uthevede glidebryterne for å fortsette',
      dragSlider: 'Dra til venstre eller høyre for å svare'
    },
    psc: {
      dragLeftRight: 'Dra til venstre eller høyre for å svare'
    },
    ps: {
      note: (value, remaining) => `Fordel ${remaining ? 'gjenværende' : ''} ${value} mellom elementene nedenfor`,
      allDone: `Ferdig`,
      total: `Total::`,
      dragSlider: 'Dra til venstre eller høyre for å svare'
    },
    cx: {
      note: 'Åpne dropbox og begynn å skrive inn svaret ditt for automatisk rulling, eller velg det manuelt'
    },
    ro: {
      note: 'Dra opp eller ned for å endre rekkefølge:'
    },
    md: {
      note1: 'Klikk på / trykk på varen du valgte for første gang.<br/> Klikk/trykk igjen for å fjerne valget.',
      note2: 'Nå kan du klikke/trykke på elementet du valgte sist<br/> Klikk/trykk igjen for å fjerne valget.',
      note3: 'Takk! Fortsett til neste spørsmål, eller klikk/trykk på et ikke–merket element for å starte på nytt.'
    },
    aro: {
      note: 'Velg ett element fra hvert par.'
    },
    wd: {
      note: 'Pass på at hver påfølgende verdi er større enn den forrige.'
    },
    emd: {
      note: 'Se videoen til slutten',
      noAnswers: 'Ikke noe svaralternativ, klikk ved siden av for å fortsette.',
      start: 'Klikk og hold nede for å starte',
      resume: 'Klikk og hold nede for å gjenoppta',
      continue: 'Du er klar! <br/> Klikk på <strong>Neste</strong> for å fortsette',
      continueMobile: 'Du er klar! <br/> Klikk <strong>HER</strong> for å fortsette',
      training: {
        session: 'Opplæringssesson',
        note: 'Avslutt opplæringen',
        moveLeft: 'Dra skiven helt <strong>tilvenstre</strong>',
        moveBottom: 'Dra skiven helt <strong>tilbunnen</strong>',
        moveRight: 'Nå drar du skiven helt <strong>tiltil høyre</strong>',
        moveTop: 'Nå drar du skiven helt <strong>tiltoppen</strong>',
        success: 'Flott jobbet!'
      }
    },
    sft: {
      noAnswers: 'Ikke noe svaralternativ, klikk ved siden av for å fortsette.',
      note: 'Svar så raskt du kan med det svaret som intuitivt føles riktig',
      imageError: 'No image exposure time chosen',
      finish: 'Du er ferdig! Klikk på Neste for å fortsette',
      training: {
        start:
          '<p>Dette spørsmålet vil raskt vise deg forskjellige ord og vil kreve at du konsentrerer deg. ' +
          'Du må reagere raskt for å svare </p> <p>Klar til å øve?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Trykk på "{buttonLeft}"`
            : (mouse ? `Klikk "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Trykk på "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Trykk på "{buttonRight}"`
            : (mouse ? `Klikk "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Trykk på "{keyBtnRight}"` : ''),
        fail: () => 'For sakte',
        success: () => 'Flott!',
        finish: () =>
          '<p><strong>Utmerket!</strong></p><p>Pass på at du ikke blir distrahert i løpet<br/> av de neste 2–3 minuttene <br />' +
          '</p><p>Klikk på Neste for å starte når du er klar</p>'
      },
      buttons: {
        start: 'Start',
        yesno: {
          left: 'Ja',
          right: 'Nei'
        },
        matches: {
          left: 'Match',
          right: 'Ikke en match'
        },
        fits: {
          left: 'Egnet',
          right: 'Ikke egnet'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Ja',
          right: 'Nei'
        },
        matchesRev: {
          left: 'Match',
          right: 'Ikke en match'
        },
        fitsRev: {
          left: 'Egnet',
          right: 'Ikke egnet'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
